import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Icon from '../Icon/Icon';
import './Alert.scss';
import { FieldErrors } from 'react-hook-form';

interface AlertProps {
  variant?: 'danger' | 'warning' | 'success' | 'info';
  message?: string;
  errors?: FieldErrors<any>;
  onClose?: Dispatch<SetStateAction<string>>;
}

export default function Alert({
  variant = 'danger',
  message,
  errors,
  onClose,
  ...props
}: AlertProps) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const util =
    errors && Object.keys(errors).length > 0
      ? (errors[Object.keys(errors)[0]]?.message as string)
      : (message ?? null);

  function clearErrorMessage() {
    setErrorMessage(null);
    if (onClose) onClose('');
  }

  const hasErrors = errors && Object.keys(errors).length > 0;

  useEffect(() => {
    const keys = Object.keys(errors || []);
    if (keys.length > 0) {
      const firstKey = keys[0];
      const firstMessage = errors?.[firstKey]?.message as string;
      setErrorMessage(firstMessage);
    } else if (message) setErrorMessage(message);
    else setErrorMessage(null);
  }, [message, hasErrors, util]);

  if (!errorMessage) return null;
  return (
    <div className={`alert ${variant}`} {...props}>
      <div className="alert__description" aria-live="assertive">
        <Icon
          name={
            ['danger', 'warning']?.includes(variant) ? 'exclamation' : 'info'
          }
        />
        <p className="caption">{errorMessage}</p>
      </div>
      <Icon className="hover" name="close" onClick={clearErrorMessage} />
    </div>
  );
}

// Ex: implementation
{
  //   <Alert message="Lorem ipsum" />
}
